module.exports = __webpack_public_path__ + "static/media/USA.88750349.png";